const ignoredResizeObserverErrors = new Set([
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
]);

export const isIgnorableResizeObserverError = (message) => (
  ignoredResizeObserverErrors.has(message)
);
